import * as React from 'react';
type Props = {
  className?: string;
};
export function Platter({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-platter"
      className={className}
    >
      <mask
        id="mask0_21_1549"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21_1549)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5C12.9598 5 13.7792 5.67021 13.9663 6.65494L13.9915 6.82191L14.0155 7.24954C17.2864 8.07855 19.7476 10.8915 19.9821 14.4561L19.9957 14.7318L20.0167 16H4V15C4 11.1871 6.54525 8.1122 10 7.24519L10 7C10 5.87608 10.8992 5 12 5ZM12 9C9.12775 9 6.75018 10.9295 6.14765 13.6399L6.10038 13.8741L6.079 14H17.92L17.9019 13.8836C17.4195 11.1973 15.2105 9.22422 12.476 9.01787L12.226 9.00401L12 9ZM21 17V19H3V17H21Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
